export var valuesQuestionReorderingMode = ["Overall", "Bucketwise", "Noreordering"];
/*

*/ 
//# sourceMappingURL=QuestionReorderingMode.js.map